import { ThemeEvents } from '@theme/events';
import { morphProductBlock } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Metal composition rings. Re-renders when the selected variant changes,
 * so variants with their own metal_composition metafield swap in place.
 */
class MetalComposition extends Component {
  /** @type {Element | null} */
  #variantUpdateTarget = null;

  connectedCallback() {
    super.connectedCallback();
    this.#variantUpdateTarget = this.closest('.shopify-section, dialog');
    this.#variantUpdateTarget?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#variantUpdateTarget?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  /** @param {Event} event */
  update = (event) => {
    morphProductBlock(this, event);
  };
}

if (!customElements.get('metal-composition')) {
  customElements.define('metal-composition', MetalComposition);
}
